module.exports = __webpack_public_path__ + "static/bw-handwave-966f0344c2e1b9f77da721b79f8cb2b9.gif";